<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="managemileage"
          class="container-fluid menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <!-- Start the code for this screen here -->
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Mileage Tracker</b>
              </span>
            </nav>
            <div v-if="failure">
              <p align="center" class="alert-danger">{{failureMessage}}</p>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label name="Date From" class="col-form-label col-form-label-sm required">Date Range</label>
              </div>
              <div class="col-12 col-md-12 d-flex align-items-center">
                <label
                  class="col-form-label col-form-label-sm"
                >{{mileage.fromDate | moment("MM/DD/YYYY")}}</label>
                <label name="Mileage" class="ml-3">-</label>
                <label
                  class="col-form-label col-form-label-sm ml-3"
                >{{mileage.toDate | moment("MM/DD/YYYY")}}</label>
              </div>
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label
                  name="Mileage"
                  class="col-form-label col-form-label-sm required"
                >Mileage (Miles)</label>
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <input
                  type="text"
                  v-validate="'required|numeric'"
                  data-vv-name="Mileage"
                  class="form-control input-sm"
                  v-model.trim="mileage.miles"
                  @input="onlyNumbers()"
                  :maxlength="4"
                  size="4"
                />
                <div v-if="errors.has('Mileage')" class="alert-danger">{{ errors.first('Mileage') }}</div>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label name="Notes" class="col-form-label col-form-label-sm required">Notes</label>
              </div>
              <div
                class="col-12 col-lg-4 col-md-12 col-sm-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <textarea
                  v-model.trim="mileage.notes"
                  v-validate="'required|max:150'"
                  class="form-control input-sm"
                  data-vv-name="Notes"
                  spellcheck="true"
                  placeholder="add notes"
                  rows="5"
                  :maxlength="150"
                />
                <div v-if="errors.has('Notes')" class="alert-danger">{{ errors.first('Notes') }}</div>
              </div>
            </div>
            <div class="center mt-2 mb-3">
              <button
                type="submit"
                class="btn btn-secondary"
                :disabled="this.submitted"
                @click="saveMileage"
              >Save</button>
            </div>
            <div class="horizontal-line"></div>
            <div
              v-if="this.showdropdown"
              class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mt-2"
            >
              <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                <label name="employee" class="col-form-label col-form-label-sm required">Employee</label>
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <select
                  v-model.trim="selectedEmpId"
                  @change="getMileagesForSelectedEmp"
                  class="form-control input-sm"
                >
                  <option disabled value>Select Employee</option>
                  <option
                    v-for="e in employees"
                    v-bind:value="e.employeeId"
                    v-bind:key="e.employeeId"
                  >{{ e.firstName }} , {{ e.lastName }}</option>
                </select>
              </div>
            </div>
            <br />
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Display Mileages</b>
              </span>
            </nav>
            <!-- Table Data start-->
            <div class="row p-2 justify-content-center">
              <div class="col">
                <div class="table-responsive table-responsive-sm tbl-mileage-tracker mb-5">
                  <table class="table table-sm table-bordered table-striped">
                    <thead>
                      <tr class="table-month-header-blue wrap-text">
                        <th v-for="(col,index) in colheaders" :key="index">
                          <span>{{col.header}}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(mileage,dindex) in mileageForDisplay" :key="dindex">
                        <td>{{mileage.fromDate | moment("MM/DD/YYYY")}}</td>
                        <td>{{mileage.toDate | moment("MM/DD/YYYY")}}</td>
                        <td>{{mileage.miles}}</td>
                        <td>{{mileage.mileageNotes}}</td>
                        <td>
                          <center>
                            <button
                              class="btn btn-secondary"
                              type="submit"
                              @click="deleteMileage(mileage.mileageId)"
                            >Delete</button>
                          </center>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!--      <template v-if="this.norecordsfound">
               <p align ="center" class="alert-danger"> No Mileage records found!!!</p>
            </template>-->
          </div>
          <!-- Container DIV Tag end-->
          <!-- End of the code for this screen here -->
        </div>
        <!-- Page Container DIV Tag end-->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import activityTraking from '../js/http-activitytracking'
import manageemployeeSvc from '../js/http-employee.js'
import { stringify } from 'querystring'
import moment from 'moment'
import util from '../js/common-utils'

export default {
  components: { MainMenu, TopHeader, BottomFooter },
  name: 'addMileage',
  data () {
    return {
      mileage: this.initializedata(), // intialize  entry fields
      submitted: false,
      employees: [],
      selectedEmpId: '',
      showdropdown: this.$session.get('user_role') != 'SR',
      saved: false,
      failure: false,
      failureMessage: "We're sorry, We're unable to save Mileage information",
      colheaders: [
        { header: 'From Date' },
        { header: 'To Date' },
        { header: 'Mileage (in Miles)' },
        { header: 'Notes' },
        { header: 'Action' }
      ],
      mileageForDisplay: [],
      norecordsfound: false
    }
  },
  methods: {
    initializedata () {
      return {
        mileageId: '',
        empId: this.$session.get('employee_id'),
        fromDate: moment().weekday(0),
        toDate: moment().weekday(6),
        miles: '',
        notes: '',
        createdDate: '',
        createdUserId: ''
      }
    },
    onlyNumbers: function () {
      this.mileage.miles = this.mileage.miles.replace(/[^0-9]/, '')
    },
    getMileagesForSelectedEmp: function (event) {
      this.retrieveMileage(this.selectedEmpId)
    },
    saveMileage () {
      this.failure = false
      this.norecordsfound = false
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          // disable submit button
          this.submitted = true
          let mileagePayload = {
            fromDate: util.formatDateMoment(this.mileage.fromDate),
            toDate: util.formatDateMoment(this.mileage.toDate),
            miles: this.mileage.miles,
            mileageEmployeeId: this.mileage.empId,
            mileageNotes: this.mileage.notes,
            // "creationD": currentDate,
            creationUserI: this.$session.get('user_id')
          }
          // console.log("Mileage to be saved:"+ JSON.stringify( mileagePayload))
          // Save
          activityTraking
            .post('/mileage/', mileagePayload)
            .then(response => {
              var savedMileage = response.data
              // console.log("Saved Mileage:"+JSON.stringify(savedMileage))
              if (savedMileage != null && savedMileage.mileageId != 0) {
                this.errors.clear()
                this.$validator.reset()
                this.mileage = this.initializedata()
                // get the Mileage info from system
                activityTraking
                  .get('/mileage/' + savedMileage.mileageId)
                  .then(Response => {
                    // console.log("Mileage returned:"+ JSON.stringify(Response.data))
                    // update the table below
                    this.mileageForDisplay.unshift(Response.data)
                  })
              }
              // else if (status=="BAD_REQUEST"){
              // this.failure = true;
              // }
              else {
                console.log('Failed to save Mileage!!')
                this.failure = true
              }
              // TODO= Handle following scenarios - 500 or any other Status Codes
            })
            .catch(e => {
              console.log('Failed: ' + e)
              this.failure = true
            })
          // enable button
          this.submitted = false
        } // end if
      })
    },
    deleteMileage (mileageId) {
      activityTraking.delete('/mileage/' + mileageId).then(Response => {
        var status = Response.data
        // console.log("Deleted resonse" +status)
        if (status == 'OK') {
          // TODO - Find a way to remove element from array with specific ID OR make Retreive Call to get Fresh Data
          this.retrieveMileage(this.mileage.empId)
          this.norecordsfound = false
        } else {
          // message that failed to delete?
          console.log('Error deleting Mileage')
        }
      })
    },
    retrieveMileage (empId) {
      // TODO Get only for 1 Week on Page Load
      this.norecordsfound = false
      activityTraking
        .get('/mileage/employee/' + empId)
        .then(response => {
          // console.log("Search Results:"+ JSON.stringify(response.data))
          if (response.data.length != 0) {
            this.norecordsfound = false
            this.mileageForDisplay = response.data
          } else {
            this.mileageForDisplay = []
            this.norecordsfound = true
          }
        })
        .catch(e => {
          console.log('Error getting mileages for employee')
          this.mileageForDisplay = []
          this.norecordsfound = true
        })
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#managemileage').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    fetchData () {
      // create objet
      if (this.showdropdown) {
        let searchEmployee = {
          firstName: '',
          lastName: '',
          roleType: '',
          statusCode: ''
        }
        manageemployeeSvc
          .post('/employee/search/', searchEmployee)
          .then(response => {
            this.employees = response.data
          })
          .catch(e => {
            console.log('Failed to load salesperson:' + e)
          })
      }
      // get activities
      this.retrieveMileage(this.mileage.empId)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>
.wrap-text {
  white-space: nowrap;
}
</style>
